// What a patient portal session may do (docs/plans/phase3-portal-feedback-kiswahili.md §3.2;
// ADR 0035). Scopes are a fixed list apart from the staff PERMISSIONS: a staff role can never
// hold one, and a staff session never satisfies a portal route. Every portal route declares
// `config.portal.scopes`; the route registry test checks it.

export const PORTAL_SCOPES = {
  'portal.self': 'See and change their own portal account, and sign out',
  'portal.appointments.read': 'See upcoming appointments',
  'portal.appointments.cancel': 'Cancel an upcoming appointment',
  'portal.bills.read': 'See bills, receipts and balances',
  'portal.results.read': 'See validated lab results',
  'portal.allergies.read': 'See recorded allergies',
  'portal.feedback.submit': 'Rate a visit and see replies to their feedback',
} as const;

export type PortalScope = keyof typeof PORTAL_SCOPES;

export const PORTAL_SCOPE_LIST = Object.keys(PORTAL_SCOPES) as readonly PortalScope[];

export function isPortalScope(value: string): value is PortalScope {
  return Object.hasOwn(PORTAL_SCOPES, value);
}
